import React, { useContext, useState, useEffect } from "react";
import { collection, query, where, onSnapshot, orderBy, limit } from "firebase/firestore";
import { MdAdd } from "react-icons/md";
import { Link } from "react-router-dom";

import MainLayout from '../layouts/MainLayout'
import UserInfos from '../components/UserInfos'
import Vehicule from '../components/Vehicule'
import {FirebaseContext} from '../services/Firebase/Context'
import {AuthContext} from '../services/Session/Context'

const Interventions = () => {
  const { user } = useContext(AuthContext)
  const { db } = useContext(FirebaseContext)
  const [records, setRecords] = useState([])

  useEffect(() => {
    if(!user) return
    const q = query(
      collection(db, "records"),
      where("organisationId", "==", user.organisationId),
      where("status", "in", ["pending", "new"]),
      orderBy("createdAt", 'desc'),
      limit(500))
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const records = [];
      querySnapshot.forEach((doc) => {
        records.push({id: doc.id, ...doc.data()});
      });
      setRecords(records)
    });
    return () => unsubscribe()
  }, [db, user])

  return (
    <MainLayout>
      <UserInfos/>
      <h1 className="text-4xl font-semibold text-gray-800 dark:text-white">
        Traitement des interventions
      </h1>
      <h2 className=" text-gray-400">Les interventions sont mises à jour en temps réel</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 my-6">
        <Link to='/app/interventions/create' className="py-2 px-4 flex justify-center items-center bg-gray-400 hover:bg-gray-500 focus:ring-gray-300 focus:ring-offset-gray-100 text-white transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-lg ">
          <button type="button" className="flex justify-center items-center">
            <MdAdd size={25}/>
            Nouveau
          </button>
        </Link>
        {
          records.map((record) => <Vehicule key={record.id}  {...record} />)
        }
      </div>
    </MainLayout>
  );
}

export default Interventions
